import type { paths } from '@pba/types-openapi-client';
import type { BodyRouteParamsRequest } from '@pba/utils';
import { type ApiClientResponse, apiClient, routes } from 'common/services';

type ResponseType = paths['/v3/transaction_items/{id}']['patch']['responses']['200']['content']['application/json'];
type TransactionRequestParams =
  paths['/v3/transaction_items/{id}']['patch']['requestBody']['content']['application/json'];

export const updateTransactionItem = async ({
  body,
  routeParams: { id },
}: BodyRouteParamsRequest<TransactionRequestParams, { id: string }>) =>
  apiClient.patch<ResponseType, ApiClientResponse<ResponseType>>(routes.transactions.updateItem(id), body);
